export default __webpack_public_path__ + "assets/icon-dirt_hand.svg";